import {
  PickupPoint,
  PointsByType,
  PointType,
  StorePoint,
  StorePointFeature
} from '../types';

export const getPointsByTypes = (
  points: PickupPoint[],
  pointTypes: PointType[]
): PointsByType[] => {
  const types = pointTypes;

  return types.map((type) => {
    return {
      type,
      points: points
        .filter((point) => point.type === type)
        .map((point) => ({
          type: 'Feature',
          id: point.id,
          geometry: {
            type: 'Point',
            coordinates: [+point.coords[1], +point.coords[0]]
          },
          properties: {
            title: point.title,
            street: point.street,
            pointType: point.type,
            cost: point.cost,
            deliveryDate: point.deliveryDate,
            openingHours: point.openingHours,
            phone: point.phone,
            pointPrefix: point.prefix,
            dayFrom: point.dayFrom,
            dayTo: point.dayTo
          }
        }))
    };
  });
};

export const getStorePoints = (points: StorePoint[]): StorePointFeature[] => {
  return points.map((point) => ({
    type: 'Feature',
    id: point.id,
    geometry: {
      type: 'Point',
      coordinates: [+point.coords[1], +point.coords[0]]
    },
    properties: {
      title: point.title,
      street: point.street
    }
  }));
};
